module.exports = require("@vscode-alt/monaco-editor/esm/vs/platform/commands/common/commands");